import { TFactoryHolidayDTO, TRESPONSE_FACTORY_HOLIDAYS } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export const HOLIDAY_LIST_TABLE_MODEL = {
  createModel: (items: TRESPONSE_FACTORY_HOLIDAYS['holidays']) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        edit: {
          hasAddRow: true,
          hasDeleteRow: true,
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'ID',
            isHidden: true,
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value: TFactoryHolidayDTO) => value.id,
              },
              metadata: {
                keyName: 'id',
                label: 'HolidayId',
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'DATE',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'date',
                setValue: (value: TFactoryHolidayDTO) => value.date,
              },
              metadata: {
                keyName: 'date',
                isRequired: true,
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'HOLIDAY',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value: TFactoryHolidayDTO) => value.description,
              },
              metadata: {
                keyName: 'description',
                isRequired: true,
              },
            },
          },
        ],
      },
      (item): TTableRowNode<TFactoryHolidayDTO> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.id || '',
            },
            {
              type: 'TEXT_CELL',
              text: item.date,
            },
            {
              type: 'TEXT_CELL',
              text: item.description,
            },
          ],
        };
      },
    );
  },
};
